import { RatingData } from '@/common/adModels';
import utils from '../utils/utils'
import sessionCookie from './sessionStart'
import axios, { AxiosRequestConfig } from 'axios';
import { get as getCookie } from 'es-cookie';

const requestConfig: AxiosRequestConfig = {
    auth: {
        username: "apiKey",
        password: "1307713F-04FD-47D0-8758-ABD356B1C159"
    }
}

const requestTreeBranchConfig: AxiosRequestConfig = {
    auth: {
        username: "apiKey",
        password: "D10FB16A-243C-4C5E-B5A0-D57032491C85"
    }
}

async function getAds(zoneKeys: string | string[], bankId: number = 0, runSelection: boolean = true) {
    const esourceid = utils.getESourceId();
    const zoneKeysString = Array.isArray(zoneKeys) ? zoneKeys.join(',') : zoneKeys;
    const dmaCode = (await sessionCookie.getDmaCode()).geodma;
    const stateCode = (await sessionCookie.getStateCode()).geostate;
    let apiUrl = `${process.env.VUE_APP_API_HOST}/ads/?zonekeys=${zoneKeysString}`

    apiUrl += `&select=` + Number(runSelection);

    if (dmaCode && dmaCode > 0) {
        apiUrl += `&dma=${dmaCode}`;
    }
    if (stateCode) {
        apiUrl += `&state=${stateCode}`;
    }
    if (esourceid) {
        apiUrl += `&esourceid=${esourceid}`;
    }
    if (bankId > 0) {
        apiUrl += `&bankId=${bankId}`;
    }
    if (navigator.userAgent) {
        apiUrl += `&useragent=${navigator.userAgent}`;
    }

    // form marketingAttributes by combining query parameters with MKT_TRACK cookie
    let mktAttributes = window.location.search.substring(1);
    let mktTrackCookie = getMktCookieQS();
    if (mktAttributes) {
        if (mktTrackCookie) {
            mktAttributes += "&" + mktTrackCookie;
        }
        apiUrl += `&marketingAttributes=${encodeURIComponent(mktAttributes)}`
    }
    else if (mktTrackCookie) {
        apiUrl += `&marketingAttributes=${encodeURIComponent(mktTrackCookie)}`
    }
    return axios.get<AdResult>(encodeURI(apiUrl), requestConfig);
}

async function getAdPlacementsInZone(zoneKey: string, bankId: number = 0, runSelection: boolean = true): Promise<AdPlacement[] | undefined> {
    const adPlacementsPromise: Promise<AdPlacement[]> = new Promise(async function (resolve, reject) {
        try {
            const resp = await getAds(zoneKey, bankId, runSelection);

            const placements = resp && resp.data && resp.data.zones && resp.data.zones.length === 1 && resp.data.zones[0] && resp.data.zones[0].placements;
            const placementsResult: AdPlacement[] | undefined = placements || undefined;

            resolve(placementsResult);
        }
        catch {
            reject("Error occurred retrieving from Ads API")
        }
    });
    return adPlacementsPromise;
}

async function getAdZones(zoneKeys: string[], runSelection: boolean = true): Promise<AdZone[]> {
    const adPlacementsPromise: Promise<AdZone[]> = new Promise(async function (resolve, reject) {
        try {
            const resp: any = await getAds(zoneKeys, 0, runSelection);
            let zones: AdZone[] = resp && resp.data && resp.data.zones;
            //to eliminate null values
            let filteredZones: AdZone[] = zones.filter(function (el) {
                return el != null;
            });

            resolve(filteredZones);
        }
        catch {
            reject("Error occured retrieving from Ads API")
        }
    });

    return adPlacementsPromise;
}


async function getAverageRate(productId: Number, date: Date | undefined = undefined) {
    let apiUrl = `${process.env.VUE_APP_API_HOST}/averagerates/?productId=${productId}`;
    if (date) {
        const formattedDate: string = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        apiUrl += `&dates=${formattedDate}`;
    }
    const resp = await axios.get(encodeURI(apiUrl), requestConfig);
    return resp;
}

async function getAverageRateOfToday(productId: Number): Promise<AveragRateProduct> {

    const averageRatesPromise: Promise<AveragRateProduct> = new Promise(async function (resolve, reject) {
        try {
            const todayDate = new Date();
            const resp = await getAverageRate(productId, todayDate);
            const product: AveragRateProduct = resp && resp.data && resp.data.products && resp.data.products.length === 1 && resp.data.products[0];
            resolve(product);
        }
        catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });

    return averageRatesPromise;
}

async function getAverageRateOfProduct(productId: Number): Promise<AveragRateProduct> {

    const averageRatesPromise: Promise<AveragRateProduct> = new Promise(async function (resolve, reject) {
        try {
            const resp = await getAverageRate(productId);
            const product: AveragRateProduct = resp && resp.data && resp.data.products && resp.data.products.length === 1 && resp.data.products[0];
            resolve(product);
        }
        catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });

    return averageRatesPromise;
}

async function getRateTable(rateTableReq: RateTable.Request): Promise<RateTable.Response> {
    const rateTablePromise: Promise<RateTable.Response> = new Promise(async function (resolve, reject) {
        try {
            // form marketingAttributes by combining query parameters with MKT_TRACK cookie
            let mktAttributes = window.location.search.substring(1);
            let mktTrackCookie = getMktCookieQS();
            if (mktAttributes) {
                if (mktTrackCookie) {
                    mktAttributes += "&" + mktTrackCookie;
                }
                rateTableReq.MarketingAttributes = encodeURIComponent(mktAttributes);
            }
            else if (mktTrackCookie) {
                rateTableReq.MarketingAttributes = encodeURIComponent(mktTrackCookie);
            }

            const apiUrl = `${process.env.VUE_APP_API_HOST}/v2/ratetableadsservice`;
            const resp = await axios.post(encodeURI(apiUrl), rateTableReq, requestConfig);
            const rateTableRecords: RateTable.Response = resp && resp.data;
            resolve(rateTableRecords);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });

    return rateTablePromise;
}

async function getRateTableAccountDetails(accountId: number, productId: number): Promise<RateTable.AccountDetails> {
    const rateTableAccountPromise: Promise<RateTable.AccountDetails> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/RateTableAccountDetails?accountId=${accountId}&productid=${productId}`
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const accountDetails: RateTable.AccountDetails = resp && resp.data;
            resolve(accountDetails);
        } catch {
            reject(new Error("Error occurred while retrieving from API"))
        }
    });
    return rateTableAccountPromise;
}

async function getBankPagePriority(url: string): Promise<BankPage.PriorityResponse> {
    const bankPagePriorityPromise: Promise<BankPage.PriorityResponse> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/bankdata`;
            const resp = await axios.get(encodeURI(apiUrl + "?url=" + url), requestConfig);
            const bankPagePriorityRecord: BankPage.PriorityResponse = resp && resp.data;
            resolve(bankPagePriorityRecord);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return bankPagePriorityPromise;
}

async function getBankPage(url: string): Promise<BankPage.Response> {
    const bankPagePromise: Promise<BankPage.Response> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/bankpage`;
            const stateCode = (await sessionCookie.getStateCode()).geostate;
            if (stateCode) {
                url += "&state=" + stateCode;
            }
            const dmaCode = (await sessionCookie.getDmaCode()).geodma;
            if (dmaCode && dmaCode != -1) {
                url += "&dmaCode=" + dmaCode;
            }
            url += "&clientIPAddress=";

            const resp = await axios.get(encodeURI(apiUrl + "?url=" + url), requestConfig);
            const bankPageRecord: BankPage.Response = resp && resp.data;
            resolve(bankPageRecord);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return bankPagePromise;
}

async function getBankReviews(url: string): Promise<BankPage.ReviewsResponse> {
    const reviewsPromise: Promise<BankPage.ReviewsResponse> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/bankreviews`;

            const resp = await axios.get(encodeURI(apiUrl + "?url=" + url), requestConfig);
            const reviewsRecord: BankPage.ReviewsResponse = resp && resp.data;
            resolve(reviewsRecord);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return reviewsPromise;
}

async function getBankAccount(accountId: number, productId: number): Promise<BankPage.BankAccountDetailsResponse> {
    const bankAccountPromise: Promise<BankPage.BankAccountDetailsResponse> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/BankAccountDetails`;
            const resp = await axios.get(encodeURI(apiUrl + "?accountId=" + accountId + "&productId=" + productId), requestConfig);
            const bankAccountRecord: BankPage.BankAccountDetailsResponse = resp && resp.data;
            resolve(bankAccountRecord);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return bankAccountPromise;
}

async function getReviewComments(threadId: number): Promise<BankPage.BankPageReviewComments> {
    const reviewCommentsPromise: Promise<BankPage.BankPageReviewComments> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/threadcomments`;
            const resp = await axios.get(encodeURI(apiUrl + "?threadId=" + threadId), requestConfig);
            const reviewCommentsRecord: BankPage.BankPageReviewComments = resp && resp.data;
            resolve(reviewCommentsRecord);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return reviewCommentsPromise;
}

async function submitVote(contentType: string, contentId: number, ipAddress: string, vote: number, userId: number): Promise<BankPage.Vote> {
    const votePromise: Promise<BankPage.Vote> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_API_HOST}/voteup`;
            const resp = await axios.get(encodeURI(apiUrl +
                "?contentType=" + contentType +
                "&contentId=" + contentId +
                "&ipAddress=" + "192.1.1.2" +
                "&vote=" + vote +
                "&userId=" + userId), requestConfig);
            const voteRecord: BankPage.Vote = resp && resp.data;
            resolve(voteRecord);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return votePromise;
}

async function updateGeoLocation(): Promise<void> {
    const rateTableAccountPromise: Promise<void> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `/ratetable/updategeolocation`
            await axios.get(encodeURI(apiUrl), requestConfig);
            //const accountDetails: RateTable.AccountDetails = resp && resp.data;
            resolve();
        } catch {
            reject(new Error("Error occurred while retrieving from API"))
        }
    });
    return rateTableAccountPromise;
}

async function getBankLocation(bankId: Number): Promise<Location[]> {
    const bankLocation: Promise<Location[]> = new Promise(async function (resolve, reject) {
        try {
            let apiUrl = `${process.env.VUE_APP_API_HOST}/locations/?bankId=${bankId}`;
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const bankLocationResp: BankLocationResponse = resp && resp.data && resp.data.banks[0];
            const bankLocationData: Location[] = bankLocationResp && bankLocationResp.locations;
            resolve(bankLocationData);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return bankLocation;
}

async function getBankLocationMap(bankId: number, state: string): Promise<Location[]> {
    const bankLocation: Promise<Location[]> = new Promise(async function (resolve, reject) {
        try {
            let apiUrl = `${process.env.VUE_APP_API_HOST}/banklocations?bankId=${bankId}&state=${state}`;
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const bankLocationResp: Location[] = resp && resp.data;
            resolve(bankLocationResp);
        } catch {
            reject(new Error("Error occured while retrieving from API111"))
        }
    });
    return bankLocation;
}

async function getState(): Promise<State[]> {
    //may not have state code until after session started initially
    const stateList: Promise<State[]> = new Promise(async function (resolve, reject) {

        try {
            let apiUrl = `${process.env.VUE_APP_API_HOST}/states`;
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const stateResponse: State[] = resp && resp.data && resp.data.states;

            resolve(stateResponse);
        } catch {
            reject(new Error("Error occured while retrieving from State API"))
        }
    });
    return stateList;
}

async function getAccountsMetadata(): Promise<AccountsMetadata> {
    const accountsMetadata: Promise<AccountsMetadata> = new Promise(async function (resolve, reject) {
        try {
            let apiUrl = `${process.env.VUE_APP_API_HOST}/accountsmetadata`;
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const accountsMetadataResp: AccountsMetadata = resp && resp.data;

            resolve(accountsMetadataResp);
        } catch {
            reject(new Error("Error occured while retrieving from Accounts Metadata API"))
        }
    });
    return accountsMetadata;
}

async function getAdDisclosure(): Promise<string> {
    const adDisclosureModalContent: Promise<string> = new Promise(async function (resolve, reject) {
        try {
            let apiUrl = `/ajax/advertisingdisclosure.aspx?mode=modal`;
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const adDisclosureModalContentResp: string = resp && resp.data;
            resolve(adDisclosureModalContentResp);
        } catch {
            reject(new Error("Error occured while retrieving from API"))
        }
    });
    return adDisclosureModalContent;
}

function getMktCookieQS(): string | null {
    const mktTrackCookie = getCookie("MKT_TRACK");
    if (!mktTrackCookie) {
        return null;
    }

    var mktTrackCookieObj: Object = JSON.parse(mktTrackCookie);
    var mktTrackCookieQS: string = utils.JSONtoQuerystring(mktTrackCookieObj);
    return mktTrackCookieQS;
}

function getTreeBranchValue(branchName: string, userId: string | undefined = undefined, attributes: object = {}): Promise<TreeBranch.Response> {
    const responsePromise: Promise<TreeBranch.Response> = new Promise(async function (resolve, reject) {
        if (!userId) {
            // If userId is not provided, attempt to retrieve sessionId
            userId = getCookie('ug');
            if (!userId) {
                // If 'ug' cookie is not present, default to failed response
                const responsePromise: TreeBranch.Response = {
                    response: '',
                    isSuccess: false
                }
                resolve(responsePromise);
                return responsePromise;
            }
        }
        const request = [{
            UserId: userId,
            BranchName: branchName,
            Attributes: attributes
        }];

        const responsePromise = getTreeBranchValues(request);
        resolve(responsePromise);
    });
    return responsePromise;
}

function getTreeBranchValues(request: Object = {}): Promise<TreeBranch.Response> {
    const responsePromise: Promise<TreeBranch.Response> = new Promise(async function (resolve, reject) {
        try {
            const apiUrl = `${process.env.VUE_APP_TREEBRANCH_API_HOST}/TreeBranchService`;
            const resp = await axios.post(encodeURI(apiUrl), request, requestTreeBranchConfig);
            var DepositAccount = (<any>window).DepositAccount;

            DepositAccount = DepositAccount || {};
            DepositAccount.treeBranch = DepositAccount.treeBranch || [];

            for (const [key, value] of Object.entries(resp.data)) {
                DepositAccount.treeBranch.push({ tree_branch_name: key, tree_branch_leaf: value });
            }

            const responsePromise: TreeBranch.Response = {
                response: resp.data,
                isSuccess: true
            }
            resolve(responsePromise);
        } catch (exception) {
            console.error(new Error("Error occurred while calling TreeBranchApi"))
            if (process.env.NODE_ENV != 'production') {
                console.error(exception);
            }

            const responsePromise: TreeBranch.Response = {
                response: '',
                isSuccess: false
            }
            resolve(responsePromise);
        }
    });
    return responsePromise;
}

async function getBankRatings(bankIds: number[]): Promise<RatingData[]> {
    const bankIdsString = bankIds.join(',');
    const apiUrl = `${process.env.VUE_APP_API_HOST}/bankstarratings?bankIds=${bankIdsString}&includeBankProducts=false`;
    const response = await axios.get(apiUrl, requestConfig);
    return response.data;
}

async function getSuggestionData(state: string, amount: number, years: string): Promise<string> {
    const suggestionsData: Promise<string> = new Promise(async function (resolve, reject) {
        try {
            let apiUrl = `${process.env.VUE_APP_PUBLIC_PATH}/wheretogrowyourcash?state=${state}&amount=${amount}&years=${years}`
            const resp = await axios.get(encodeURI(apiUrl), requestConfig);
            const html = resp && resp.data;
            resolve(html);
        } catch {
            reject(new Error("Error occured while retrieving from Accounts Metadata API"))
        }
    });
    return suggestionsData;
}

export default {
    getAdPlacementsInZone,
    getAdZones,
    getAverageRateOfToday,
    getAverageRateOfProduct,
    getRateTable,
    getRateTableAccountDetails,
    getBankPagePriority,
    getBankPage,
    getBankReviews,
    getBankAccount,
    getReviewComments,
    getBankLocation,
    getBankLocationMap,
    getState,
    getAccountsMetadata,
    submitVote,
    updateGeoLocation,
    getAdDisclosure,
    getTreeBranchValue,
    getTreeBranchValues,
    getBankRatings,
    getSuggestionData
};